var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.01;isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cancel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.09,
    y: -0.09,
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09,47.91a40,40,0,1,1,40,40A40,40,0,0,1,8.09,47.91Zm8,0a32,32,0,1,0,32-32A32,32,0,0,0,16.09,47.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75,47.91,66.92,34.74a4,4,0,1,0-5.66-5.66L48.09,42.25,34.92,29.08a4,4,0,1,0-5.66,5.66L42.43,47.91,29.26,61.08a4,4,0,0,0,5.66,5.66L48.09,53.57,61.26,66.74a4,4,0,0,0,5.66-5.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.b36cb1eeb57516a4afced180315d2707.svg";
export { ForwardRef as ReactComponent };